<div class="p-sub-column-layout01">
  <div class="p-sub-column-layout01__title p-sub-column-layout01__title--has-btn">
    <div class="p-heading-area01">
      <h2 class="p-heading-area01__title c-heading-2">{{ amountHeaderLabel }}</h2>
    </div>
    <button
      id="payment-amount-detail-button"
      class="c-btn-tertiary c-btn-tertiary--xs"
      (click)="this.clickPaymentDetails($event)"
    >
      <span class="c-btn-tertiary__text" [innerHTML]="'label.details2' | staticMsg"></span>
    </button>
  </div>
  <div class="p-sub-column-layout01__body">
    <div class="p-sub-column-layout01__item">
      <dl *ngIf="!isKeepMyFare" class="c-flex-list01">
        <div class="c-flex-list01__item c-flex-list01__item--sb c-flex-list01__item--center">
          <dt class="c-flex-list01__title">
            <div>
              <span
                class="c-flex-list01__text-strong p-sub-column-layout01__text-total"
                [innerHTML]="'label.totalAmount' | staticMsg"
              ></span>
            </div>
          </dt>
          <dd class="c-flex-list01__contents">
            <div class="c-flex-list01__contents-item">
              <span class="c-amount c-amount--price c-flex-list01__text-strong">
                <span
                  class="c-amount__num c-amount__num--fs24"
                  [innerHTML]="this.totalPrice | amountFormat : undefined : this.totalPriceCurrency"
                ></span>
              </span>
            </div>
            <div *ngIf="this.appliedDiscountType" class="c-flex-list01__contents-item">
              <span class="c-amount c-amount--price">
                <span class="c-amount__num c-amount__num--fs20">
                  <del
                    [innerHTML]="this.totalPriceBeforeApplying | amountFormat : undefined : this.totalPriceCurrency"
                  ></del>
                </span>
              </span>
            </div>
          </dd>
        </div>
      </dl>
      <dl *ngIf="isKeepMyFare" class="c-flex-list01">
        <div class="c-flex-list01__item c-flex-list01__item--sb c-flex-list01__item--center">
          <dt class="c-flex-list01__title u-content-width-max50">
            <span
              class="c-flex-list01__text-strong p-sub-column-layout01__text-total"
              [innerHTML]="'label.paymentTotalAmount1' | staticMsg"
            ></span>
          </dt>
          <dd class="c-flex-list01__contents">
            <div class="c-flex-list01__contents-item">
              <span class="c-amount c-amount--price c-flex-list01__text-strong">
                <span
                  class="c-amount__num c-amount__num--fs24"
                  [innerHTML]="this.totalPriceOfKeepMyFare | amountFormat : undefined : this.KeepMyFareCurrencyCode"
                ></span>
              </span>
            </div>
          </dd>
        </div>
        <div class="c-flex-list01__item c-flex-list01__item--sb c-flex-list01__item--center">
          <dt class="c-flex-list01__title u-content-width-max50">
            <span
              class="p-sub-column-layout01__item-tag"
              [innerHTML]="'label.keepMyFareTotalAmount' | staticMsg"
            ></span>
          </dt>
          <dd class="c-flex-list01__contents">
            <div class="c-flex-list01__contents-item">
              <span class="c-amount c-amount--price">
                <span
                  class="c-amount__num c-amount__num--fs20"
                  [innerHTML]="this.totalPrice | amountFormat : undefined : this.totalPriceCurrency"
                ></span>
              </span>
            </div>
            <div *ngIf="this.appliedDiscountType" class="c-flex-list01__contents-item">
              <span class="c-amount c-amount--price">
                <span class="c-amount__num c-amount__num--fs20">
                  <del
                    [innerHTML]="this.totalPriceBeforeApplying | amountFormat : undefined : this.totalPriceCurrency"
                  ></del>
                </span>
              </span>
            </div>
          </dd>
        </div>
      </dl>
      <div *ngIf="this.isApplicableDiscountCode">
        <button
          id="payment-amount-adaptation-button-input"
          class="c-coupon-adaptation"
          (throttleClick$)="this.clickUsePromotionCode()"
          aswThrottleClick
        >
          <span class="c-coupon-adaptation__label" [innerHTML]="'label.usePromotionCode' | staticMsg"></span>
          <span class="u-visually-hidden" [innerHTML]="'reader.applyPromotion' | staticMsg"></span>
          <span
            class="c-coupon-adaptation__status"
            aria-hidden="true"
            [innerHTML]="'button.PromotionCode' | staticMsg"
          ></span>
        </button>
      </div>
      <div *ngIf="!this.isApplicableDiscountCode && this.appliedDiscountType === 'AAM'">
        <button
          id="payment-amount-adaptation-button-cancel"
          class="c-coupon-adaptation"
          (click)="this.clickCancelPromotionCode()"
        >
          <span class="c-coupon-adaptation__label">{{ this.appliedAamDiscountCode }}</span>
          <span
            class="u-visually-hidden"
            [innerHTML]="'reader.cancelPromotion' | staticMsg : { '0': this.appliedAamDiscountCode }"
          ></span>
          <span
            class="c-coupon-adaptation__status"
            aria-hidden="true"
            [innerHTML]="'button.promoChancel' | staticMsg"
          ></span>
        </button>
      </div>
    </div>
    <div *ngIf="isPc && isDisplayPlanReviewLink" class="p-sub-column-layout01__item">
      <ul class="p-sub-column-layout01__list">
        <li class="p-sub-column-layout01__list-item">
          <a
            id="payment-amount-external_primary8"
            (throttleClick$)="clickPrevPlanInfo()"
            class="p-sub-column-layout01__list-link"
            [innerHTML]="'label.backToPlanConfirmation' | staticMsg"
            aswThrottleClick
          >
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
